import { render, staticRenderFns } from "./NormalTag.vue?vue&type=template&id=697a8ae4&scoped=true"
import script from "./NormalTag.vue?vue&type=script&lang=js"
export * from "./NormalTag.vue?vue&type=script&lang=js"
import style0 from "./NormalTag.vue?vue&type=style&index=0&id=697a8ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697a8ae4",
  null
  
)

export default component.exports